module.exports = "# Esmeralda and Goober Opening Story\n\nYouTube: zB36hR6ioxM\n\n## Notes\nEsmeralda snaps Goober out of his trance and they try to escape the shack (2:51).\n\n# Intro to Song of Stuff\n\nYouTube: 6Qrl2o8No9M\n\n## Notes\nIntro to Song of Stuff (0:06).\n\n# Song of Stuff\n\nYouTube: G45Uo4UKmxc\n\n## Notes\nSong of Stuff music video based on the Story of Stuff project (3:13).\n"


//////////////////
// WEBPACK FOOTER
// ./programs/zeroHeroes/sections/12_esOpeningStory/level6_opening.md
// module id = 1840
// module chunks = 2